import type { ObjectProposalGenerationType } from '@econtractor/types';
import DocumentTableRow from './DocumentTableRow';

export interface DocumentsTableBodyProps {
    rows: ObjectProposalGenerationType[];
    deletingId: number | null;
    onCreateFromGeneration: (row: ObjectProposalGenerationType) => void;
    onToWarehouse: (row: ObjectProposalGenerationType) => void;
    onPayment: (row: ObjectProposalGenerationType) => void;
    onDelete: (row: ObjectProposalGenerationType) => void;
    onSendEmail: (row: ObjectProposalGenerationType) => void;
}

const DocumentsTableBody = ({
    rows,
    deletingId,
    onCreateFromGeneration,
    onToWarehouse,
    onPayment,
    onDelete,
    onSendEmail,
}: DocumentsTableBodyProps) => {
    return (
        <tbody>
            {rows.map((row) => (
                <DocumentTableRow
                    key={`${row.source || 'object'}-${row.ID}`}
                    row={row}
                    deletingId={deletingId}
                    onCreateFromGeneration={onCreateFromGeneration}
                    onToWarehouse={onToWarehouse}
                    onPayment={onPayment}
                    onDelete={onDelete}
                    onSendEmail={onSendEmail}
                />
            ))}
        </tbody>
    );
};

export default DocumentsTableBody;
